<div class="job-post-main">
    <div class="logo-sec">
        <div class="row">
            <div class="col-md-3 company-logo" *ngIf="formattedCompLogo">
                <img src="{{formattedCompLogo}}" alt="Logo">
            </div>
            <div class="col-md-3 imagility-logo">
                <img src="../../../../assets/imagility-white-logo.png" alt="Imagility Logo">
            </div>
        </div>
    </div>
    
    <div class="row container-fluid">
        <div class="col-md-12">
            <h2>US Labour Condition Application Notifications</h2>
            <div class="cont-sec">
                <h3>US Labour Condition Application (LCA)</h3>
                <p>
                    The Labor Condition Application (LCA) is an application filed by a U.S. employer on behalf of a foreign 
                    national worker who will apply for certain types of non-immigrant work visa. An employer generally submits 
                    the LCA ahead of hiring workers in the H-1B, H-1B1, and E-3 statuses.
                </p>
            </div>
        </div>
    </div>
    <div class="row container-fluid tab-container pt-4 pb-2">
        <div class="col">
            <mat-tab-group (selectedTabChange)="onTabChanged($event)">
                <mat-tab label="Today’s post {{todayCount? '(' + todayCount + ')' :null}}"> 
                    <div class="row bg-white p-0 pt-4 pb-4">
                        <div class="col-12 p-0 pt-2 pb-2">
                            <table class="im-card-no-border-table table im-card-table-noborder-spacing table-header_uppercase table-striped-simple" mat-table [dataSource]="dataSource" matSort>
                                <ng-container *ngFor="let column of todaysColumns" [matColumnDef]="column.columnDef">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{column.header}} </th>
                                    <td mat-cell *matCellDef="let row" [ngClass]="[column.columnDef == 'companyName' ? 'mat-cell-wrap-text1' : '']">
                                        <span *ngIf="column.columnDef =='companyName'">
                                            {{row.companyName}}
                                        </span>
                                        <span *ngIf="column.columnDef =='socJobTitle'">
                                            {{row.socJobTitle}}
                                        </span>
                                        <span *ngIf="column.columnDef =='socCode'">
                                            {{row.socCode}}
                                        </span>
                                        <span *ngIf="column.columnDef =='location'">
                                            {{row.location}}
                                        </span>
                                        <span *ngIf="column.columnDef =='startDate'">
                                            {{row.startDate | ImgDateFormat}}
                                        </span>
                                        <span *ngIf="column.columnDef =='endDate'">
                                            {{row.endDate | ImgDateFormat}}
                                        </span>
                                        <span *ngIf="column.columnDef =='noOfPositions'">
                                            {{row.noOfPositions}}
                                        </span>
                
                                        <span class="column.customClass" *ngIf="column.columnType=='icon'">
                                            <div class="row" >
                                                <button type="button" class="btn-cust mr-1" (click)="openModal(row)">DETAILS</button>
                                                <button *ngIf="row.documents.length > 0" type="button" class="btn-cust" (click)="openFilesModal(row)">FILES</button>
                                            </div>
                                        </span>
                
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                                </tr>
                            </table>
                
                            <!-- <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator> -->
                            <mat-paginator [pageSizeOptions]="pageSizeOptions"
                            [pageSize]="pageSize"
                            [length] = "todayCount"
                            (page)="paginationEvent($event)"></mat-paginator>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="This week {{thisWeekCount? '(' + thisWeekCount + ')' :null}}"> 
                    <div class="row bg-white p-0 pt-4 pb-4">
                        <div class="col-12 p-0 pt-2 pb-2">
                            <table class="im-card-no-border-table table im-card-table-noborder-spacing table-header_uppercase table-striped-simple" mat-table [dataSource]="dataSource" matSort>
                                <ng-container *ngFor="let column of thisWeekColumns" [matColumnDef]="column.columnDef">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{column.header}} </th>
                                    <td mat-cell *matCellDef="let row" [ngClass]="[column.columnDef == 'companyName' ? 'mat-cell-wrap-text1' : '']">
                                        <span *ngIf="column.columnDef =='companyName'">
                                            {{row.companyName}}
                                        </span>
                                        <span *ngIf="column.columnDef =='socJobTitle'">
                                            {{row.socJobTitle}}
                                        </span>
                                        <span *ngIf="column.columnDef =='socCode'">
                                            {{row.socCode}}
                                        </span>
                                        <span *ngIf="column.columnDef =='location'">
                                            {{row.location}}
                                        </span>
                                        <span *ngIf="column.columnDef =='startDate'">
                                            {{row.startDate | ImgDateFormat}}
                                        </span>
                                        <span *ngIf="column.columnDef =='endDate'">
                                            {{row.endDate | ImgDateFormat}}
                                        </span>
                                        <span *ngIf="column.columnDef =='noOfPositions'">
                                            {{row.noOfPositions}}
                                        </span>
                
                                        <span class="column.customClass" *ngIf="column.columnType=='icon'">
                                            <div class="row" >
                                                <button type="button" class="btn-cust mr-1" (click)="openModal(row)">DETAILS</button>
                                                <button *ngIf="row.documents.length > 0" type="button" class="btn-cust" (click)="openFilesModal(row)">FILES</button>
                                            </div>
                                        </span>
                
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="thisWeekdisplayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: thisWeekdisplayedColumns;">
                                </tr>
                            </table>
                
                            <!-- <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator> -->
                            <mat-paginator [pageSizeOptions]="pageSizeOptions"
                            [pageSize]="pageSize"
                            [length] = "thisWeekCount"
                            (page)="paginationEvent($event)"></mat-paginator>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Last week {{lastWeekCount? '(' + lastWeekCount + ')' :null}}">
                    <div class="row bg-white p-0 pt-4 pb-4">
                        <div class="col-12 p-0 pt-2 pb-2">
                            <table class="im-card-no-border-table table im-card-table-noborder-spacing table-header_uppercase table-striped-simple" mat-table [dataSource]="dataSource" matSort>
                                <ng-container *ngFor="let column of lastWeekcolumns" [matColumnDef]="column.columnDef">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{column.header}} </th>
                                    <td mat-cell *matCellDef="let row" [ngClass]="[column.columnDef == 'companyName' ? 'mat-cell-wrap-text1' : '']">
                                        <span *ngIf="column.columnDef =='companyName'">
                                            {{row.companyName}}
                                        </span>
                                        <span *ngIf="column.columnDef =='socJobTitle'">
                                            {{row.socJobTitle}}
                                        </span>
                                        <span *ngIf="column.columnDef =='socCode'">
                                            {{row.socCode}}
                                        </span>
                                        <span *ngIf="column.columnDef =='location'">
                                            {{row.location}}
                                        </span>
                                        <span *ngIf="column.columnDef =='startDate'">
                                            {{row.startDate | ImgDateFormat}}
                                        </span>
                                        <span *ngIf="column.columnDef =='endDate'">
                                            {{row.endDate | ImgDateFormat}}
                                        </span>
                                        <span *ngIf="column.columnDef =='noOfPositions'">
                                            {{row.noOfPositions}}
                                        </span>
                
                                        <span class="column.customClass" *ngIf="column.columnType=='icon'">
                                            <div class="row" >
                                                <button type="button" class="btn-cust mr-1" (click)="openModal(row)">DETAILS</button>
                                                <button *ngIf="row.documents.length > 0" type="button" class="btn-cust" (click)="openFilesModal(row)">FILES</button>
                                            </div>
                                        </span>
                
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="lastWeekdisplayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: lastWeekdisplayedColumns;">
                                </tr>
                            </table>
                
                            <!-- <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator> -->
                            <mat-paginator [pageSizeOptions]="pageSizeOptions"
                            [pageSize]="pageSize"
                            [length] = "lastWeekCount"
                            (page)="paginationEvent($event)"></mat-paginator>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
    <!-- Posted Details Modal Dialog -->
    <div *ngIf="isPostedDtlsModalOpen" class="modal">
        <div class="modal-content">
        <span class="close" (click)="closeModal()">&times;</span>
        <h1>Post Details</h1>
        <mat-divider class="mt-2 pb-4"></mat-divider>
        <dl>
            <dt>LCA ID:</dt>
            <dd>{{ modalData.lcaId }}</dd>
            <div class="clearfix"></div>
        </dl>
        <dl>
            <dt>Posted Date:</dt>
            <dd>{{ modalData.postedDate | date:'mediumDate' }}</dd>
            <div class="clearfix"></div>
        </dl>
        <dl>
            <dt>Petitioner:</dt>
            <dd>{{ modalData.petitioner }}</dd>
            <div class="clearfix"></div>
        </dl>
        <dl>
            <dt>Location:</dt>
            <dd>{{ modalData.location }}</dd>
            <div class="clearfix"></div>
        </dl>
        <dl>
            <dt>#Positions:</dt>
            <dd>{{ modalData.numPositions }}</dd>
            <div class="clearfix"></div>
        </dl>
        </div>
    </div>

    <!-- Post Files Modal Dialog -->
    <div *ngIf="isPostFilesModalOpen" class="modal">
        <div class="modal-content">
        <span class="close" (click)="closeFilesModal()">&times;</span>
        <h1>Post Files</h1>
        <mat-divider class="mt-2 pb-4"></mat-divider>
        <ul>
            <li *ngFor="let doc of docData">
                <a href="javascript:void(0)" (click)="openDoc(doc)">{{doc.fileName}}</a>
            </li>
        </ul>
        </div>
    </div>
</div>